module.exports = __webpack_public_path__ + "static/img/ikonaWord.59d78ab5.jpg";